import { config } from 'config';
import axios from 'axios';

export class DataService {

  constructor(loading = true) {
    this._axios = axios.create(config);
    this._loading = loading;
    this.init();
  }

  init() {
    if(this._loading){
      this._axios.interceptors.request.use(this.showLoading.bind(this), this.hideLoading.bind(this))
      this._axios.interceptors.response.use(this.showLoading.bind(this), this.hideLoading.bind(this))
    }
  }

  showLoading(data) {
    this.toggleLoading()
    return data
  }

  hideLoading(error) {
    this.toggleLoading()
    return Promise.reject(error.response)
  }

  toggleLoading() {
    let loading = document.getElementById('loader');
    if(loading)
      loading.classList.toggle('show')
  }

  request(options) {
    return this._axios.request(options)
  }

}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/data/service.js